// extracted by mini-css-extract-plugin
export default {"tags":"Tags-tags-MyS6m"};